import { HeartIcon } from 'lucide-react';

export const Footer = () => {
  return (
    <div className="mt-16 flex items-center justify-center gap-2 rounded-lg bg-white/5 px-4 py-6 text-sm text-steel-500">
      <HeartIcon className="inline-block size-4" /> Fprints is proudly ad-free,
      open-source, and by the community.
    </div>
  );
};
